import Vue from 'vue';
import * as constDefine from '@/store/constDefine';
import router from '@/router'
import crypto from "../util/crypto"
import auth from "../util/auth"
import http from "../util/http"
import countryCode from "../json/country_code.json"
import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

export default {
    isLineApp() {
        if (typeof window === 'undefined' || !navigator) {
            return false;
        }

        const ua = navigator.userAgent || navigator.vendor || window.opera;

        // 使用正則表達式不區分大小寫 (/i) 尋找 "Line" 字眼
        return /Line/i.test(ua);
    },
    getLineToken() {
        let lineToken = localStorage.getItem('lineToken');
        if (lineToken !== null && lineToken !== undefined && lineToken !== '' && lineToken !== 'null') {
            return crypto.uriComponentToObject(lineToken)
        }
        return ""
    },
    getEnvLiffId() {
        let liffId = '';
        let envLiffId = process.env.VUE_APP_LIFF_ID;
        liffId = envLiffId === undefined && envLiffId === null && envLiffId === "" ? "" : envLiffId;
        return liffId
    }
}